import { render, staticRenderFns } from "./CalendarItemDetailsShort.vue?vue&type=template&id=e57c48a6"
import script from "./CalendarItemDetailsShort.vue?vue&type=script&lang=js"
export * from "./CalendarItemDetailsShort.vue?vue&type=script&lang=js"
import style0 from "./CalendarItemDetailsShort.vue?vue&type=style&index=0&id=e57c48a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports